import { Flex, FlexProps } from "@chakra-ui/react";
import { Dancer, Options, formationToSvg } from "sdsvg";
import { Markdown } from "./Markdown";

const PLACEHOLDER = "#010101";

export const Formation = ({
  content,
  options,
}: {
  content: string | Dancer[];
  options?: Options;
}) => {
  let svg = formationToSvg(content, {
    ...options,
    body: { size: 21, strokeColor: PLACEHOLDER, ...options?.body },
    label: { family: "inherit", ...options?.label },
  }).replaceAll(PLACEHOLDER, "currentColor");

  const viewBoxMatch = svg.match(/viewBox="[^ ]+ [^ ]+ [^ ]+ ([^"]+)"/);
  if (viewBoxMatch) {
    const height = (Number(viewBoxMatch[1]) * 1.3) / 21;
    svg = svg.replace("<svg ", `<svg height="${height}em" `);
  }

  return <div dangerouslySetInnerHTML={{ __html: svg }} />;
};

export const FormationTable = ({
  content,
  options = {},
  ...rest
}: {
  content: [string | Dancer[], string, Options | undefined][];
  options?: Options;
} & FlexProps) => {
  return (
    <Flex
      align="stretch"
      justify="space-evenly"
      flexWrap="wrap"
      gap={3}
      {...rest}
    >
      {content.map(([formation, caption, override], i) => (
        <Flex
          key={i}
          basis={100 / content.length}
          grow={1}
          align="center"
          justify="center"
          direction="column"
        >
          <Formation
            content={formation}
            options={{ ...options, ...override }}
          />
          <Markdown content={caption} center={true} inline={true} />
        </Flex>
      ))}
    </Flex>
  );
};
